import React from 'react';
import { Select } from '@rendering/components';
import { EFFECT_TYPE_LIST } from 'src/config/constants';
import { SelectEvent } from 'src/types';
import Engraving from './engraving';
import LetterPressView from './letterpress';
import Glow from './glow';
import { DocumentEffect, EffectType } from 'src/config/effects';

interface EffectsViewProps {
    id: string;
    setEffect: (data: { id: string; effectType: string }) => void;
    updateEffectProperty: (data: { id: string; property: string; value: any }) => void;
    effect?: DocumentEffect;
}

const EffectsView = (props: EffectsViewProps) => {
    const { id, effect, setEffect, updateEffectProperty } = props;

    const effectTypeValue = EFFECT_TYPE_LIST.find((opt) => opt.value === effect?.type) || EFFECT_TYPE_LIST[0];

    return (
        <>
            <div className='effect-type-selector'>
                <Select
                    label='Effect Type'
                    value={effectTypeValue}
                    className='effect-type-select'
                    data-testid='effect-type-selector'
                    options={EFFECT_TYPE_LIST}
                    onChange={(e: SelectEvent) => setEffect({ id, effectType: e.value as string })}
                    isClearable={false}
                    isSearchable={false}
                />
            </div>
            {effect?.type === EffectType.ENGRAVING && (
                <Engraving id={id} color={effect.color} updateEffectProperty={updateEffectProperty} />
            )}
            {effect?.type === EffectType.LETTERPRESS && (
                <LetterPressView id={id} effect={effect} updateEffectProperty={updateEffectProperty} />
            )}
            {effect?.type === EffectType.GLOW && (
                <Glow id={id} effect={effect} updateEffectProperty={updateEffectProperty} />
            )}
        </>
    );
};

export default EffectsView;
